import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "./utils";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

export const roleTemplateApi = createApi({
  reducerPath: "roleTemplates",
  baseQuery: baseQueryWithReauth,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  tagTypes: ["RoleTemplates"],
  endpoints: (builder) => ({
    listRoleTemplates: builder.query({
      query: ({ token, clinicId }) => {
        return apiFunction({ token, clinicId }, "/api/clinic/role-templates/list", "POST");
      },
      providesTags: ["RoleTemplates"],
    }),
    createRoleTemplate: builder.mutation({
      query: ({ token, clinicId, name, permissions }) => {
        return apiFunction(
          { token, clinicId, name, permissions },
          "/api/clinic/role-templates/create",
          "POST"
        );
      },
      invalidatesTags: ["RoleTemplates"],
    }),
    updateRoleTemplate: builder.mutation({
      query: ({ token, clinicId, templateId, name, permissions }) => {
        return apiFunction(
          { token, clinicId, templateId, name, permissions },
          "/api/clinic/role-templates/update",
          "POST"
        );
      },
      invalidatesTags: ["RoleTemplates"],
    }),
    deleteRoleTemplate: builder.mutation({
      query: ({ token, clinicId, templateId }) => {
        return apiFunction(
          { token, clinicId, templateId },
          "/api/clinic/role-templates/delete",
          "POST"
        );
      },
      invalidatesTags: ["RoleTemplates"],
    }),
    getAvailablePermissions: builder.query({
      // clinicId yalnız admin klinik detayından gelir; personelde sunucu oturumdan alır.
      query: ({ token, clinicId }) => {
        return apiFunction(
          clinicId ? { token, clinicId } : { token },
          "/api/clinic/role-templates/available-permissions",
          "POST"
        );
      },
    }),
  }),
});

export const {
  useListRoleTemplatesQuery,
  useLazyListRoleTemplatesQuery,
  useCreateRoleTemplateMutation,
  useUpdateRoleTemplateMutation,
  useDeleteRoleTemplateMutation,
  useGetAvailablePermissionsQuery,
  useLazyGetAvailablePermissionsQuery,
} = roleTemplateApi;
